import { QueryBuilderSelect } from './QueryBuilderSelect';
import { QueryBuilderSelectWithLinkWrapper } from './QueryBuilderSelect.styles';
import { RedirectButton } from '../Buttons';
import { ConditionSingleValueSelectWithButtonProps } from '../types';

export const QueryBuilderSelectWithButton = <TValue extends string>({
  link,
  tooltipContent,
  onButtonClick,
  ...props
}: ConditionSingleValueSelectWithButtonProps<TValue>) => {
  return (
    <QueryBuilderSelectWithLinkWrapper>
      <QueryBuilderSelect {...props} />
      {props.value && (
        <RedirectButton onClick={onButtonClick} tooltipContent={tooltipContent} link={link} />
      )}
    </QueryBuilderSelectWithLinkWrapper>
  );
};
